// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  formValues: { [string]: any },
  customProps: any
};

@computeData({ includeData: true, includeVisible: false })
export default class DataHandler extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'event',
      title: '输出',
      event: 'pipeOut'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '转化',
      name: 'transform'
    },
    {
      title: '输出',
      name: 'output'
    }
  ];

  actionTransform = (data: void, dynamicData: any) => {
    this.props.setCompInputData(dynamicData, () => {
      this.actionOutput()
    })
  };

  actionOutput = () => {
    const { callActions, jsEnv } = this.props
    callActions('pipeOut', jsEnv.getComponentData())
  };

  actionInput = (data: void, dynamicData: any) => {
    // 兼容旧版 actionInput， 新版使用 @computeData 里的数据绑定
    this.props.setCompInputData(dynamicData)
  };

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/DataHandler.js